export class HSLAdapter {
  connect(streaming, config, onSuccess) {
    const url =
      streaming?.version === 'v2'
        ? `https://${streaming?.wsHost}:${streaming?.hlsPort}${streaming?.path}/index.m3u8?token=${config.streamToken}`
        : `https://${streaming?.wsHost}:${streaming?.hlsPort}/${config.streamToken}${streaming?.path}/index.m3u8`;

    console.log(
      'RTSP Link: ',
      `rtsp://${streaming?.serial || streaming?.username}:${streaming?.streamToken}@${streaming?.wssHost}:${streaming?.rtspPort || '10554'}${streaming?.path || streaming?.sourcePath || `/${streaming?.source}`}`,
    );
    this.url = url;
    onSuccess(url);
  }

  destroy() {
    console.log('DESTROYING THIS INSTANCE');
  }
}
